// extracted by mini-css-extract-plugin
export var buttonAvatarIcon = "signinButton-module--buttonAvatarIcon--2mGh8";
export var avatarIcon = "signinButton-module--avatarIcon--1qzfq";
export var container = "signinButton-module--container--tvIMu";
export var popOut = "signinButton-module--popOut--XNoky";
export var popOutOpen = "signinButton-module--popOutOpen--m7D87";
export var userInfoText = "signinButton-module--userInfoText--yeQtk";